import React from 'react';
import Header from '../../Components/Header/header';
import Card from '../../Components/Card/card';
import Data from '../../Components/App/Data';
import Reach from '../../Components/Reach/reach';
import FootPage from '../../Components/FooterPage/footPage';
import './Menu.css';

const menuPage = [
  {
    img: 'menu.png',
    caption: 'Our Menu',
  }
]

const menuPic = [
  {
    img: 'table.jpg',
    caption: 'Click here for Reservation',
  }
]

const menuPlate = [
  {
    title: 'Greed Salad',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
    menuImg:'greek.jpg',
  },
  {
    title: 'Bruchette',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
    menuImg:'brochettes.jpg',
  },
  {
    title: 'Lemon Desert',
    text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor',
    menuImg:'lemon-dessert.jpg',
  }
]


export default function Menu() {

  const cards = Data.map(item => {
    return (
      <Card 
      key={item.id}
      {...item}
      />
    )
  })
  return (
    <div className='menu'>
       <Header />
        {menuPage.map((sticker, index) => (
          <div className='sticker-cover' key={index}>
            <img src={`/images/${sticker.img}`} alt='sticker' className='sticker-image' />
            <span className='sticker-text'>{sticker.caption}</span> 
          </div>
        ))}
        <div className="wrap-card">
            <h4 className='menu-text'>Today's Special</h4>
         <div className="container-card">
          {cards}
         </div>
         </div>
         {menuPic.map((table, index) => (
          <div className='table-cover' key={index}>
            <img src={`/images/${table.img}`} alt='sticker' className='table-image' />
            <span className='table-text'><a href='/#'>{table.caption}</a></span> 
          </div>
        ))}
        <div className='menu-container'>
          {menuPlate.map((plate, index) => (
            <div key={index} className='main-menu'>
              <div className='cover-menu'>
               <h4 className='topText-title'>{plate.title}</h4>
               <p className='mainText'>{plate.text}</p>
             </div>
            <div className='menuMain-menu'>
              <img src={`/images/${plate.menuImg}`} alt='main-menu' className="main-picture" />
              <img src={`/images/${plate.menuImg}`} alt='main-menu' className="main-picture" />
              <img src={`/images/${plate.menuImg}`} alt='main-menu' className="main-picture" />
            </div>  
            </div>
          ))}
        </div>
        <Reach />
        <div className="footPage">
          <FootPage />
        </div>
    </div>
  )
}
